import React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import { Box, Divider, Typography } from '@mui/material';
import RedeemIcon from '@mui/icons-material/Redeem';
import { useRouter } from 'next/router';
import CountdownTimer from '../CountdownTImer';
import { LoadingButton } from '@mui/lab';

const CouponPop = ({ open, onClose, user, onClick, premiumFeatures, loading }) => {
  const popData = premiumFeatures && premiumFeatures?.banner_pop && premiumFeatures?.banner_pop?.length > 0 ? premiumFeatures?.banner_pop[0] : {}
  const router = useRouter();
  const action = (
    <React.Fragment>
      <Button disableElevation
        sx={{
          width: '100%', background: 'hsl(233.56deg 31.71% 91.96%)',
          '&:hover': { background: 'hsl(233.56deg 35.37% 87.14%)', },
          mt: 2.5, p: 1, color: 'primary.main', fontWeight: 600
        }}
        size="small" onClick={onClose} variant="contained"
      >
        Redeem Coupon
      </Button>
    </React.Fragment>
  );
  return (
    popData && popData?.active ?
      <div>
        <Snackbar
          open={open}
          // autoHideDuration={6000}
          // onClose={onClose}
          message="Note archived"
          // action={action}
          sx={{ borderRadius: "8px", boxShadow: 10, border: '2px solid', borderColor: 'hsl(184.62deg 31.71% 91.96%)' }}
        >
          <Box sx={{ bgcolor: '#fff', maxWidth: { md: 337, sm: '100%', xs: '100%' }, textAlign: 'center', borderRadius: "5px", position: 'relative' }}>
            <Box sx={{ bgcolor: popData?.backgroundColor ?? "#020e4a", color: '#fff', borderRadius: "7px" }}>
              <IconButton sx={{ mt: 3, bgcolor: '#ffffff1a', color: '#fff' }}><RedeemIcon /></IconButton>
              <Typography variant="body2" component="div" sx={{ m: 2 }}>
                {user ? `Special Offer Just for You!` : `Exclusive Offer Just for You!`}
              </Typography>
              <Divider color="#fff" sx={{ width: '9%', mx: 'auto', my: 3, height: 2 }} />
              {user ? null :
                <Typography variant="body2" component="div" sx={{ mx: 2, mb: 1.5 }}>
                  Sign up now and grab
                </Typography>}
              <Typography variant='h4' sx={{ fontWeight: 600, pb: user ? 1 : 2.5 }}>{popData?.offer}&nbsp;OFF</Typography>
              {user ?
                <Typography variant='h6' sx={{ pb: 3, fontSize: '.9rem', fontWeight: 600, color: 'hsl(184.62deg 31.71% 91.96%)' }}>{popData?.offerDesc}</Typography>
                : null}
            </Box>
            <Box sx={{ p: 2.5 }}>
              <CountdownTimer targetDateTime={popData?.targetDateTime} sx={{ mb: 2, color: 'primary.main' }} />
              {user ?
                <Typography variant="caption" sx={{ color: '#555' }}>
                  {popData?.targetDateTime && <> Expires <b>{popData?.targetDateTime}</b>.</>} {popData?.bannerDesc}
                </Typography>
                : <Typography variant="caption" sx={{ color: '#555' }}>
                  {popData?.bannerDesc}
                </Typography>}
              <LoadingButton
                disableElevation
                loading={loading}
                sx={{
                  width: '100%', background: 'hsl(233.56deg 31.71% 91.96%)',
                  '&:hover': { background: 'hsl(233.56deg 35.37% 87.14%)', },
                  mt: 2.5, p: 1, color: 'primary.main', fontWeight: 600
                }}
                size="small"
                onClick={(e) => {
                  user ? onClick(e, popData?.coupon) :
                    router.push({
                      pathname: '/auth',
                      query: { from: router.asPath },
                    })
                }}
                variant="contained"
              >
                {popData?.buttonText}
              </LoadingButton>
            </Box>
            <Button
              disableElevation
              sx={{
                position: 'absolute', '&:hover': { background: 'transparent', color: '#fff' }, top: 5, right: -5, background: 'transparent',
                color: '#ffffff9a', fontWeight: 600, fontSize: '.6rem', borderRadius: '12px', px: 0, py: .1
              }}
              size="small"
              onClick={onClose}
              variant="contained"
            >
              close
            </Button>
          </Box>
        </Snackbar>
      </div> : null
    // <Dialog open={open} onClose={onClose}>
    //   <DialogTitle>Popup Title</DialogTitle>
    //   <DialogContent>
    //     <DialogContentText>Popup Content</DialogContentText>
    //   </DialogContent>
    //   <DialogActions>
    //     <Button onClick={onClose}>Close</Button>
    //   </DialogActions>
    // </Dialog>
  );
};

export default CouponPop;



{/* <Box
  sx={{
    '& .brand-accent, .brand-accent:after': {
      backgroundColor: '#daebd1',
    },
    '& .card-background:after, .card-background:before': {
      content: '""',
      position: 'absolute',
      borderRadius: '50%',
      padding: '978px',
      backgroundColor: '#fff',
    },
    '& .card-background ': {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'transparent',
    },
    '& .card-background:after': {
      zIndex: 2,
      opacity: 0.5,
      backgroundColor: '#daebd1',
    },
    '& .card-background:before': {
      zIndex: 1,
    },
    '& .content-container': {
      position: 'relative',
      width: '100%',
      padding: ' 1.4rem',
    },
    '& .card-background-container': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      maxWidth: '100%',
      height: 0,
      paddingTop: 'calc(10.15% + 1px)',
    },
    '& figure': {
      margin: 0,
      padding: 0,
      border: 0,
      fontSize: '100%',
      verticalAlign: 'baseline',
      background: 'transparent',
    }
  }}>
  <div className="card-background-container text-align-center brand-accent">
    <figure className="card-background brand-accent">
    </figure>
  </div>
  <div class="content-container brand-accent content-container--with-icon">
  </div>
</Box> */}
